module.exports = "/fonts/vendor/quasar-extras/fontawesome/fa-brands-400.woff?8b7a9afd7b95f62e6ee8a72930bfb9ed";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/fontawesome/fa-brands-400.woff
// module id = JSBv
// module chunks = 49